import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, Pagination, Scrollbar } from "swiper/modules";

export default class extends Controller {
    static targets = [ "swiperContainer" ]
    static values = {
        destroyBreakpoint: Number
    }

    connect() {
        this.swipers = []
        this.handleResize()
        window.addEventListener("resize", this.handleResize)
    }

    disconnect() {
        this.destroyAllSwipers()
        window.removeEventListener("resize", this.handleResize)
    }

    handleResize = () => {
        this.swiperContainerTargets.forEach((container, index) => {
            const disableBreakpoint = parseInt(container.dataset.breakpointDisable, 10) || 768
            const shouldDestroy = window.innerWidth >= disableBreakpoint

            if (shouldDestroy) {
                this.destroySwiperAt(index)
            } else {
                this.initSwiperAt(container, index)
            }
        })
    }

    initSwiperAt(container, index) {
        if (container.dataset.swiperInitialized === "true") return

        const config = {
            modules: [ Navigation, Pagination, Scrollbar ],
            createElements: true,
            loop: true,
            loopAdditionalSlides: 4,
            slidesPerView: 'auto',
        }

        // Pagination
        if (container.hasAttribute("data-enable-pagination")) {
            let pagination = container.querySelector(".swiper-pagination")
            if (!pagination) {
                pagination = document.createElement("div")
                pagination.className = "swiper-pagination"
                container.appendChild(pagination)
            }
            config.pagination = {
                el: pagination,
                clickable: true
            }
        }

        // Navigation
        if (container.hasAttribute("data-enable-navigation-dark")) {
            let next = container.querySelector(".swiper-button-next")
            let prev = container.querySelector(".swiper-button-prev")

            if (!next) {
                next = document.createElement("div")
                next.className = "swiper-button-next icon-swiper-right-dark"
                container.appendChild(next)
            }

            if (!prev) {
                prev = document.createElement("div")
                prev.className = "swiper-button-prev icon-swiper-left-dark"
                container.appendChild(prev)
            }

            config.navigation = {
                nextEl: next,
                prevEl: prev
            }
        }

        if (container.hasAttribute("data-enable-navigation-light")) {
            let next = container.querySelector(".swiper-button-next")
            let prev = container.querySelector(".swiper-button-prev")

            if (!next) {
                next = document.createElement("div")
                next.className = "swiper-button-next icon-swiper-right-light"
                container.appendChild(next)
            }

            if (!prev) {
                prev = document.createElement("div")
                prev.className = "swiper-button-prev icon-swiper-left-light"
                container.appendChild(prev)
            }

            config.navigation = {
                nextEl: next,
                prevEl: prev
            }
        }

        const swiper = new Swiper(container, config)

        container.dataset.swiperInitialized = "true"
        container.dataset.swiperIndex = index
        container.classList.add(`swiper-${index}`)
        this.swipers[index] = swiper
    }

    destroySwiperAt(index) {
        const swiper = this.swipers[index]
        const container = this.swiperContainerTargets[index]

        if (swiper) {
            swiper.destroy(true, true)
            this.swipers[index] = null
        }

        if (container) {
            container.dataset.swiperInitialized = "false"
            container.querySelectorAll(".swiper-button-next, .swiper-button-prev, .swiper-pagination").forEach(el => {
                el.remove()
            })
        }
    }

    destroyAllSwipers() {
        this.swipers.forEach((swiper, index) => {
            if (swiper) {
                swiper.destroy(true, true)
                this.swipers[index] = null
            }
        })

        this.swiperContainerTargets.forEach(container => {
            container.dataset.swiperInitialized = "false"
            container.querySelectorAll(".swiper-button-next, .swiper-button-prev").forEach(el => {
                el.remove()
            })
            container.querySelectorAll(".swiper-pagination").forEach(el => {
                el.remove()
            })
        })
    }
}
